import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14.872 11.13a3.001 3.001 0 1 0 -4.29 3.514","key":"svg-0"}],["path",{"d":"M10 18h-5a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v3","key":"svg-1"}],["path",{"d":"M6 12h.01","key":"svg-2"}],["path",{"d":"M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.24 2.24 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.24 2.24 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071z","key":"svg-3"}]]

const IconCashBanknoteHeart = createReactComponent('outline', 'cash-banknote-heart', 'CashBanknoteHeart', __iconNode);

export default IconCashBanknoteHeart;